const maxAttempts = 20;

function scaleMap(map: HTMLMapElement, attempt: number = 0) {
    const img = document.querySelector(`img[usemap="#${map.name}"]`) as HTMLImageElement;

    // Scaling before the image is ready would read offsetWidth as 0 and
    // collapse all coordinates. The image isn't in the document yet if
    // TinyFormattedContent's replacer hasn't swapped it in — nothing to
    // listen on, so retry on a timer.
    if (!img) {
        if (attempt < maxAttempts) {
            setTimeout(() => scaleMap(map, attempt + 1), 100);
        }

        return;
    }

    // Still downloading — continue when it has loaded. The callback
    // re-queries the image, so this also works if the element has been
    // replaced by the time the event fires.
    if (!img.complete) {
        img.addEventListener("load", () => scaleMap(map, attempt + 1), { once: true });

        return;
    }

    // Loaded but not laid out yet (or just detached). No event fires for
    // this, so retry on a timer.
    if (!img.offsetWidth) {
        if (attempt < maxAttempts) {
            setTimeout(() => scaleMap(map, attempt + 1), 100);
        }

        return;
    }

    const baseWidth = Number(img.getAttribute("width")) || img.naturalWidth || img.width;
    const scale = baseWidth ? img.offsetWidth / baseWidth : 1;

    for (const area of Array.from(map.areas) as HTMLAreaElement[]) {
        area.coords = area.dataset.originalCoords
            .split(',')
            .map((coord) => Math.round(Number(coord) * scale))
            .join(',');
    }
}

function fixImageMaps() {
    const maps = document.getElementsByTagName('map');

    for (let i = 0; i < maps.length; i++) {
        // Remember the stored coordinates on the element itself, so repeated
        // calls scale from the original coordinate system instead of
        // compounding the scaling of a previous call.
        for (const area of Array.from(maps[i].areas) as HTMLAreaElement[]) {
            if (!area.dataset.originalCoords) {
                area.dataset.originalCoords = area.coords;
            }
        }

        scaleMap(maps[i]);
    }
}

export default fixImageMaps;
